"use client";

import { useRef } from "react";
import { ArrowRight } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const features = [{
  number: "01",
  title: "Engenharia de Precisão.",
  body: "Sistemas otimizados para máxima eficiência industrial.",
  focal: false
}, {
  number: "02",
  title: "Tecnologia Spraying.",
  body: "Representante exclusivo da Spraying Systems Co. desde 1993.",
  focal: true
}, {
  number: "03",
  title: "Suporte Especializado.",
  body: "Consultoria técnica dedicada para cada setor de atuação.",
  focal: false
}];
export default function Intelligence() {
  const container = useRef<HTMLDivElement>(null);
  const pinRef = useRef<HTMLDivElement>(null);
  const eyebrowRef = useRef<HTMLSpanElement>(null);
  useGSAP(() => {
    const el = container.current;
    const pinEl = pinRef.current;
    if (!el || !pinEl) return;
    const mm = gsap.matchMedia();
    mm.add({
      isDesktop: "(min-width: 1024px) and (prefers-reduced-motion: no-preference)",
      isMobile: "(max-width: 1023px) and (prefers-reduced-motion: no-preference)",
      reduced: "(prefers-reduced-motion: reduce)"
    }, ctx => {
      const conditions = ctx.conditions as {
        isDesktop: boolean;
        isMobile: boolean;
        reduced: boolean;
      };
      if (conditions.reduced) {
        gsap.set(".intel-card", {
          opacity: 1,
          y: 0
        });
        gsap.set(".intel-heading > *", {
          opacity: 1,
          y: 0
        });
        return;
      }
      if (conditions.isDesktop) {
        ScrollTrigger.create({
          trigger: el,
          start: "top top+=96",
          end: "bottom bottom-=20%",
          pin: pinEl,
          pinSpacing: false
        });
        if (eyebrowRef.current) {
          gsap.fromTo(eyebrowRef.current, {
            opacity: 0.6
          }, {
            opacity: 1,
            ease: "none",
            scrollTrigger: {
              trigger: ".intel-card:first-child",
              start: "top 90%",
              end: "top 60%",
              scrub: true
            }
          });
        }
      }
      gsap.set(".intel-heading > *", {
        y: 24
      });
      gsap.to(".intel-heading > *", {
        opacity: 1,
        y: 0,
        duration: 0.9,
        stagger: 0.1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 82%",
          once: true
        }
      });
      gsap.set(".intel-card", {
        y: 40
      });
      gsap.to(".intel-card", {
        opacity: 1,
        y: 0,
        duration: 0.9,
        stagger: 0.12,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".intel-cards",
          start: "top 85%",
          once: true
        }
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31170" id="pharmacomplianceprecisioncoating" data-nav="light" ref={container} className="relative bg-background text-foreground overflow-hidden" style={{
    paddingTop: "clamp(6rem, 11vw, 9rem)",
    paddingBottom: "clamp(6rem, 11vw, 9rem)"
  }}>
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-[40%]" style={{
      background: "radial-gradient(ellipse 80% 100% at 50% 120%, hsl(215 90% 45% / 0.08), transparent 65%)"
    }} />

      <div className="relative mx-auto w-full" style={{
      maxWidth: "1440px",
      paddingLeft: "clamp(1.25rem, 5vw, 4rem)",
      paddingRight: "clamp(1.25rem, 5vw, 4rem)"
    }}>
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-6">
          {}
          <div className="lg:col-span-5">
            <div ref={pinRef} className="intel-heading flex flex-col">
              <span ref={eyebrowRef} className="font-default" style={{
              opacity: 0,
              color: "hsl(215 90% 45%)",
              fontSize: "0.6875rem",
              fontWeight: 500,
              letterSpacing: "0.22em",
              textTransform: "uppercase",
              lineHeight: 1
            }}>
                Eurocontrol
              </span>

              <h2 className="font-default mt-6" style={{
              opacity: 0,
              color: "hsl(220 22% 6%)",
              fontSize: "clamp(2.5rem, 5.6vw, 5rem)",
              fontWeight: 450,
              letterSpacing: "-0.03em",
              lineHeight: 0.98
            }}>
                Excelência em pulverização.
              </h2>

              <p className="font-default mt-6 max-w-md" style={{
              opacity: 0,
              color: "hsl(215 12% 40%)",
              fontSize: "clamp(1.0625rem, 1.15vw, 1.2rem)",
              fontWeight: 350,
              letterSpacing: "-0.005em",
              lineHeight: 1.55
            }}>
                Soluções técnicas de alta performance.
              </p>
            </div>
          </div>

          {}
          <div className="lg:col-span-7">
            <div className="intel-cards flex flex-col space-y-8">
              {features.map((feature, i) => <div key={feature.number} data-index={i} className="intel-card relative" style={{
              opacity: 0
            }}>
                  {}
                  {feature.focal && <div aria-hidden="true" className="pointer-events-none absolute -inset-8 -z-10" style={{
                background: "radial-gradient(ellipse at center, hsl(215 90% 45% / 0.1), transparent 65%)",
                filter: "blur(60px)"
              }} />}

                  <div className="group relative overflow-hidden transition-all duration-[400ms]" style={{
                backdropFilter: "blur(24px) saturate(140%)",
                WebkitBackdropFilter: "blur(24px) saturate(140%)",
                backgroundColor: "hsl(210 10% 92% / 0.4)",
                border: "1px solid hsl(210 10% 85%)",
                borderRadius: "28px",
                padding: "clamp(2rem, 3.5vw, 2.5rem)",
                transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
              }}>
                    {}
                    <div className="font-default" style={{
                  color: "hsl(215 90% 45%)",
                  fontSize: "clamp(2rem, 3vw, 2.75rem)",
                  fontWeight: 350,
                  letterSpacing: "-0.02em",
                  lineHeight: 1
                }}>
                      {feature.number}
                    </div>

                    <h3 className="font-default mt-4" style={{
                  color: "hsl(220 22% 6%)",
                  fontSize: "clamp(1.35rem, 1.9vw, 1.75rem)",
                  fontWeight: 500,
                  letterSpacing: "-0.015em",
                  lineHeight: 1.15
                }}>
                      {feature.title}
                    </h3>

                    <p className="font-default mt-4 max-w-lg" style={{
                  color: "hsl(215 12% 40%)",
                  fontSize: "clamp(0.9375rem, 1vw, 1rem)",
                  fontWeight: 400,
                  lineHeight: 1.6
                }}>
                      {feature.body}
                    </p>

                    <div className="mt-8">
                      <Link to="/ProductsPage" className="group/link inline-flex items-center gap-2 font-default transition-colors duration-[240ms]" style={{
                    color: "hsl(215 12% 40%)",
                    fontSize: "0.9375rem",
                    fontWeight: 400
                  }}>
                        <span className="transition-colors duration-[240ms] group-hover/link:[color:hsl(215_90%_45%)]">
                          Saber mais
                        </span>
                        <ArrowRight className="size-4 transition-all duration-[240ms] group-hover/link:translate-x-1 group-hover/link:[color:hsl(215_90%_45%)]" strokeWidth={1.25} aria-hidden="true" />
                      </Link>
                    </div>

                    {}
                    <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-[400ms] group-hover:opacity-100" style={{
                  borderRadius: "28px",
                  boxShadow: "inset 0 0 40px hsl(215 90% 45% / 0.05)"
                }} />
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}